import * as aor from "react-admin";
import React from "react";
import CardActions from "@material-ui/core/CardActions";

const MyToolbar = props => (
    <aor.Toolbar {...props}>
        <aor.SaveButton
            redirect={`/customers/${props.record.customer_id}/show`}
            submitOnEnter={true}
        />
    </aor.Toolbar>
);

const Actions = ({ basePath, data }) => {
    return (
        <CardActions
            style={{ zIndex: 2, display: "inline-block", float: "right" }}
        >
            <aor.ListButton basePath="/customers" />
        </CardActions>
    );
};

export default props => (
    <aor.Edit
        {...props}
        undoable={false}
        actions={<Actions />}
        title={"resources.customers-mappings.nameSingular"}
    >
        <aor.SimpleForm toolbar={<MyToolbar />}>
            <aor.ReferenceField
                label="resources.customers.nameSingular"
                source="customer_id"
                reference="customers"
                linkType={false}
            >
                <aor.TextField source="name" />
            </aor.ReferenceField>
            <aor.ReferenceField
                label="resources.companies.nameSingular"
                source="company_id"
                reference="companies"
                linkType={false}
                allowEmpty
            >
                <aor.TextField source="name" />
            </aor.ReferenceField>
            <aor.TextField source="active_installations" />
            <aor.TextField source="booked_installations" />
        </aor.SimpleForm>
    </aor.Edit>
);



// WEBPACK FOOTER //
// ./src/resources/CustomersMapping/Edit.js